module.exports = __webpack_public_path__ + "staticesp/media/gif-dimen6.437469a5.gif";